import { DEFAULT_WELCOME_MESSAGE } from '../constants/welcomeMessage';

type WelcomeMessageSettings = {
  welcomeMessage?: string | null;
  showWelcomeMessage?: boolean | null;
};

export const getVisibleWelcomeMessage = (
  settings: WelcomeMessageSettings | null | undefined,
): string | null => {
  const message = settings?.welcomeMessage?.trim();
  return settings?.showWelcomeMessage && message ? message : null;
};

/** the default message every account starts with. */
export const isUntouchedWelcomeMessage = (
  message: string | null | undefined,
): boolean => {
  const trimmed = message?.trim();
  return !trimmed || trimmed === DEFAULT_WELCOME_MESSAGE;
};
